export default {
  edit_note: 'Editează nota',
  add_note: 'Adaugă notă ',
  update: 'Actualizează produsul',
  feedback: {
    item_sold_out_one: 'Ne pare rău, dar momentan nu avem {{items}}.',
    item_sold_out_few: 'Ne pare rău, momentan nu mai avem {{items}}.',
    item_sold_out_other: 'Ne pare rău, dar momentan nu avem {{items}}.',
    item_unavailable:
      'Acest produs este disponibil doar începând cu {{schedule}}. Schimbă ora comenzii sau elimină produsul pentru a comanda.',
  },
  buttons: {
    update: 'Actualizează',
  },
};
